module.exports = __webpack_public_path__ + "img/核心技术--图像处理.d69834d9.png";